<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19v2ykW/tc-custom/9781338184655.jpg?1700250648919" alt="This image is the cover for the book Top Dog, The Chocolate Lab"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Top Dog, The Chocolate Lab
      </h1>
      <p class="bookDescription body article font2">
        <b>Revenge is sweet as a boy and his puppies fight to save the family candy business in this pawtastic romp from the author of <i>Tug-of-War</i>.</b><br/><br/>Mason and Hannah Cabot have their hands full with Labrador pups Cocoa, Nilla, and Licorice. Keeping chocolate away from candy-crazy Cocoa is practically a full-time job! But when a rival candy company tries to put the Cabots’ chocolate shop out of business, Mason knows he’s got another job to do. He isn’t about to let some big corporation steal their recipes, take their customers, or mess with their puppies. This means war!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eric Luper
      </h2>
      
      <p class="authorDescription body article"> Eric Luper has written books for kids of all ages, including the YA novel <I>Seth Baumgartner's Love Manifesto</I>. He loves excitement and is always looking for his next adventure. Eric has fibbed his way into a tour of the ultra-secret PEZ headquarters, rebuilt a castle in France, explored the tunnels under Paris and Istanbul, escaped hungry crocodiles in Costa Rica, and rafted down the Colorado River. He lives with his family in Albany, New York. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Scholastic
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?45282b9b